module.exports = __webpack_public_path__ + "static/Paper-Less-Operations-dec8bbdf979dd3de90d8c431c65c58a4.jpg";